module.exports = __webpack_public_path__ + "img/calculadora.3e90b2fb.jpeg";